import React from 'react';
import PropTypes from 'prop-types';
import StatusChip from 'routes/App/ordersV2/OrdersList/components/StatusChip';
import IconStatusSign from 'assets/IconStatusSign';
import StatusPopover from 'routes/App/ordersV2/OrdersList/components/StatusPopover';
import {
  ORDER,
  ORDER_CHANNELS,
  ORDER_SOURCE,
  ORDER_STATUS
} from 'helpers/constants/orders_v2';
import {
  checkIsFutureOrder,
  checkIsReadyOrder
} from 'helpers/functionUtils/ordersUtilsV2';

const getGtmVar = (state) => {
  return 'orderStatus'.concat(state[0].toUpperCase() + state.slice(1));
};

const GetStatusChip = ({text, state, show, onClick}) =>
  show && (
    <li>
      <div onClick={onClick} data-gtm={getGtmVar(state)}>
        <StatusChip state={state} data-gtm={getGtmVar(state)}>
          <IconStatusSign data-gtm={getGtmVar(state)} />
          <span data-gtm={getGtmVar(state)}>{text}</span>
        </StatusChip>
      </div>
    </li>
  );

GetStatusChip.propTypes = {
  text: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default function StatusButton({
  order,
  onStatusChange,
  pickupReadyEnabled,
  serviceFeatures
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <div>
      <StatusChip
        state={
          order[ORDER.ORDER_STATUS] && order[ORDER.ORDER_STATUS].toLowerCase()
        }
        onClick={handleClick}
      >
        <IconStatusSign />
        {pickupReadyEnabled ? (
          <span>
            {checkIsReadyOrder(order, pickupReadyEnabled, serviceFeatures)
              ? ORDER_STATUS.READY
              : order[ORDER.ORDER_STATUS] || 'New'}
          </span>
        ) : (
          <span>{order[ORDER.ORDER_STATUS] || 'New'}</span>
        )}
      </StatusChip>
      <StatusPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        onItemClick={(data) => {
          handleClose();
          onStatusChange(data);
        }}
        order={order}
      >
        {pickupReadyEnabled ? (
          <GetStatusChip
            text='New'
            state='new'
            show={
              order[ORDER.ORDER_STATUS] !== ORDER_STATUS.NEW &&
              order[ORDER.ORDER_STATUS] !== ORDER_STATUS.FUTURE &&
              order[ORDER.ORDER_STATUS] !== ORDER_STATUS.READY &&
              !checkIsFutureOrder(order) &&
              !checkIsReadyOrder(order, pickupReadyEnabled, serviceFeatures)
            }
            onClick={() => {
              handleClose();
              onStatusChange(ORDER_STATUS.NEW);
            }}
          />
        ) : (
          <GetStatusChip
            text='New'
            state='new'
            show={
              order[ORDER.ORDER_STATUS] !== ORDER_STATUS.NEW &&
              order[ORDER.ORDER_STATUS] !== ORDER_STATUS.FUTURE &&
              !checkIsFutureOrder(order)
            }
            onClick={() => {
              handleClose();
              onStatusChange(ORDER_STATUS.NEW);
            }}
          />
        )}
        {pickupReadyEnabled ? (
          <GetStatusChip
            text='Accepted'
            state='accepted'
            show={
              order[ORDER.ORDER_STATUS] !== ORDER_STATUS.ACCEPTED &&
              order[ORDER.ORDER_STATUS] !== ORDER_STATUS.READY &&
              !checkIsReadyOrder(order, pickupReadyEnabled, serviceFeatures)
            }
            onClick={() => {
              handleClose();
              onStatusChange(ORDER_STATUS.ACCEPTED);
            }}
          />
        ) : (
          <GetStatusChip
            text='Accepted'
            state='accepted'
            show={order[ORDER.ORDER_STATUS] !== ORDER_STATUS.ACCEPTED}
            onClick={() => {
              handleClose();
              onStatusChange(ORDER_STATUS.ACCEPTED);
            }}
          />
        )}
        <GetStatusChip
          text='Completed'
          state='completed'
          show={
            order[ORDER.ORDER_STATUS] !== ORDER_STATUS.COMPLETED
            // order[ORDER.ORDER_STATUS] !== ORDER_STATUS.FUTURE &&
            // !checkIsFutureOrder(order)
          }
          onClick={() => {
            handleClose();
            onStatusChange(ORDER_STATUS.COMPLETED);
          }}
        />
        <GetStatusChip
          text='Cancelled'
          state='canceled'
          show={
            order[ORDER.ORDER_STATUS] !== ORDER_STATUS.CANCELLED &&
            order[ORDER.CHANNEL] !== ORDER_CHANNELS.STREAM_EVENT &&
            order[ORDER.CHANNEL] !== ORDER_CHANNELS.SPOTON &&
            order[ORDER.SOURCE] !== ORDER_SOURCE.OTTER
            //  order[ORDER.ORDER_STATUS] !== ORDER_STATUS.FUTURE &&
            //  checkIsFutureOrder(order)
          }
          onClick={() => {
            handleClose();
            onStatusChange(ORDER_STATUS.CANCELLED);
          }}
        />
      </StatusPopover>
    </div>
  );
}

StatusButton.propTypes = {
  order: PropTypes.object,
  onStatusChange: PropTypes.func,
  pickupReadyEnabled: PropTypes.bool,
  serviceFeatures: PropTypes.array
};

StatusButton.defaultProps = {
  order: {},
  onStatusChange: () => {},
  pickupReadyEnabled: false,
  serviceFeatures: []
};
